import './Statistics.css'

function Statistics({ statistics, includeVAT = true }) {
  if (!statistics) {
    return <div className="stats-empty">Nėra statistikos duomenų</div>
  }

  const vatMultiplier = includeVAT ? 1.21 : 1.0

  const {
    totalPurchase,
    totalSale,
    totalPurchaseCost: rawTotalPurchaseCost,
    totalSaleRevenue: rawTotalSaleRevenue,
    weightedPrice: rawWeightedPrice,
    balance: rawBalance
  } = statistics

  const totalPurchaseCost = rawTotalPurchaseCost * vatMultiplier
  const totalSaleRevenue = rawTotalSaleRevenue * vatMultiplier
  const weightedPrice = rawWeightedPrice * vatMultiplier
  const balance = rawBalance * vatMultiplier

  return (
    <div className="statistics">
      <div className="stats-grid">
        <div className="stat-card purchase">
          <div className="stat-icon">📥</div>
          <div className="stat-content">
            <h3>Pirkimas (P+)</h3>
            <div className="stat-value">{totalPurchase.toFixed(2)} kWh</div>
            <div className="stat-cost">{totalPurchaseCost.toFixed(2)} EUR</div>
          </div>
        </div>

        <div className="stat-card sale">
          <div className="stat-icon">📤</div>
          <div className="stat-content">
            <h3>Pardavimas (P-)</h3>
            <div className="stat-value">{totalSale.toFixed(2)} kWh</div>
            <div className="stat-cost">+{totalSaleRevenue.toFixed(2)} EUR</div>
          </div>
        </div>

        <div className="stat-card weighted">
          <div className="stat-icon">💰</div>
          <div className="stat-content">
            <h3>Svertinė Kaina</h3>
            <div className="stat-value">{weightedPrice.toFixed(4)} EUR/kWh</div>
            <div className="stat-hint">Vidutinė kaina pagal suvartojimą</div>
          </div>
        </div>

        <div className={`stat-card balance ${balance >= 0 ? 'positive' : 'negative'}`}>
          <div className="stat-icon">{balance >= 0 ? '✅' : '⚠️'}</div>
          <div className="stat-content">
            <h3>Balansas</h3>
            <div className="stat-value">
              {balance >= 0 ? '+' : ''}{balance.toFixed(2)} EUR
            </div>
            <div className="stat-hint">
              {balance >= 0 ? 'Pajamos > Išlaidos' : 'Išlaidos > Pajamos'}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Statistics
